import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SweetAlertService } from '../../services/sweet-alert.service';

@Component({
  selector: 'app-warning-icon',
  templateUrl: './warning-icon.component.html',
  styleUrls: ['./warning-icon.component.scss']
})
export class WarningIconComponent implements OnInit, OnDestroy {
  showWarningIcon = false;
  private routerSubscription: Subscription = new Subscription();

  // Routes that are protected by RoleBasedGuard
  private protectedRoutes = [
    '/organization',
    '/contact',
    '/payment-info',
    '/funding-opportunities',
    '/FAQ',
    '/applications',
    '/contracts',
    '/documentlibrary',
    '/external-contact',
    '/external-payment-info',
    '/external-active-assignment'
  ];

  constructor(
    private router: Router,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {

    this.checkIfProtectedRoute(this.router.url);


    this.routerSubscription = this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.checkIfProtectedRoute(event.url);
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  // Routes that should not show the warning icon even if they start with a protected route prefix
  private excludedRoutes = [
    '/contact-verify-passport'
  ];

  private checkIfProtectedRoute(url: string): void {
    // Check if the URL is in the excluded routes list
    if (this.excludedRoutes.some(route => url.startsWith(route))) {
      this.showWarningIcon = false;
      return;
    }
    this.showWarningIcon = url === '/' || this.protectedRoutes.some(route => url.startsWith(route));
  }

  onWarningIconClick(): void {
    this.sweetAlertService.fire({
      title: 'Lock Account',
      html: 'This will log out and block your account.<br>Are you sure you want to lock your account?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['/account-lock-redirect']);
      }
    });
  }
}
